import { createReduxHooks } from "@skydio/react_util/src/hooks-core";

import type { AppStore } from "state/store";

export const { useSelector, useShallowSelector, useDispatch } = createReduxHooks<AppStore>();
